import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-modal', 'accept', 'Jah');
Labels.set('ui-modal', 'decline', 'Ei');
Labels.set('ui-modal', 'dismiss', 'OK');
Labels.set('ui-modal', 'close', 'Sulge hüpikaken');
Labels.set('ui-modal', 'back', 'Tagasi');
Labels.set('ui-modal', 'opened', 'Hüpikaken on avatud');
Labels.set('ui-modal', 'exitLabel', 'Sulgemiseks vajuta ESC-nuppu');
